import {InformativeMetrics} from "@/pages/pagespeed/report/body/performance/InformativeMetrics";
import {PerformanceAnalysis} from "@/pages/pagespeed/report/body/performance/PerformanceAnalysis.tsx";
import {PerformanceMetrics} from "@/pages/pagespeed/report/body/performance/PerformanceMetrics.tsx";
import {NetworkStep, PagespeedLHR} from "@/pages/pagespeed/types.ts";

interface PerformanceTabProps {
  lhr: PagespeedLHR;
  steps: NetworkStep[];
}
export const PerformanceTab = ({lhr, steps}: PerformanceTabProps) => (
  <div className="mt-3">
    <h5 className="fw-semibold mt-3">Performance Metrics</h5>
    <PerformanceMetrics audits={lhr.audits} categories={lhr.categories} />
    <InformativeMetrics audits={lhr.audits} />
    <h5 className="fw-semibold mt-3">Analysis</h5>
    <PerformanceAnalysis steps={steps} />
  </div>
);
